module.exports = __webpack_public_path__ + "static/media/centos.2bf7ac7e.svg";